<template>
  <div>
      <el-card class="box-card">
          <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/ClothManage' }">用户管理</el-breadcrumb-item>
              <el-breadcrumb-item>列表</el-breadcrumb-item>
          </el-breadcrumb>
      </el-card>
      <el-row style="margin-top:20px;">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-row :gutter="10" style="display:flex;align-items:center">
                        <el-col :span="1.5">
                            <div class="grid-content bg-purple">
                                <span style="font-size:14px">微信名称:</span>
                            </div>
                        </el-col>
                        <el-col :span="3"
                            ><div class="grid-content bg-purple">
                                <el-input v-model="searchInfo.nickName"  placeholder="请输入微信名称" clearable></el-input></div
                        ></el-col>
                        <el-col :span="1.5" style="margin-left:10px">
                            <div class="grid-content bg-purple">
                                <span style="font-size:14px">手机号:</span>
                            </div>
                        </el-col>
                        <el-col :span="3"
                            ><div class="grid-content bg-purple">
                                <el-input v-model="searchInfo.phone"  placeholder="请输入手机号" clearable></el-input></div
                        ></el-col>
                       <el-col :span="1.5" style="margin-left:10px">
                            <div class="grid-content bg-purple">
                                <span style="font-size:14px">用户类型:</span>
                            </div>
                        </el-col>
                        <el-col :span="3">
                             <el-select v-model="searchInfo.memberType" placeholder="请选择用户类型">
                                    <el-option
                                    v-for="item in memberTypeList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                        </el-col>
                        <el-col :span="3">
                            <el-button type="primary" icon="el-icon-search" @click="search()">查询</el-button>
                             <el-button style="background-color: #ffb135;color: #fff" icon="el-icon-refresh-left" @click="reset()">重置</el-button>
                        </el-col>
                    </el-row>
                    <el-table :data="tableData" style="width: 100%;margin:20px 0px" border>
                        <el-table-column :resizable="false" type="index" label="序号" width="100" align="center">
                            <template slot-scope="scope">{{ scope.$index + 1 + searchInfo.pageSize * (searchInfo.pageNum - 1) }}</template>
                        </el-table-column>
                        <el-table-column prop="nickName" label="微信名称" :resizable="false" align="center"></el-table-column>
                        <el-table-column prop="phone" label="手机号" :resizable="false" align="center"></el-table-column>
                        <el-table-column prop="openId" label="唯一标识码" :resizable="false" align="center"></el-table-column>
                        <el-table-column prop="remark" label="备注信息" :resizable="false" align="center"></el-table-column>
                        <el-table-column prop="memberType" label="用户类型" :resizable="false" width="100" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.memberType == 0">非会员</span>
                                <span v-else style="color: #ff0000">普通会员</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" :resizable="false" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="openRemarkDia(scope.row.id)">设置备注信息</el-button>
                                <el-button :disabled="scope.row.memberType == 1" type="text" size="small" @click="toSetMember(scope.row.id)">设为会员</el-button>
                                <el-button :disabled="scope.row.memberType == 0" type="text" size="small" @click="cancelMember(scope.row.id)">取消会员</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="searchInfo.pageNum"
                        :page-size="searchInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </el-card>
            </el-col>
        </el-row>
        <div>
          <el-dialog title="设置备注信息" :visible.sync="addDialogVisible" width="33%" :before-close="handleToClose" :close-on-click-modal="false">
              <el-form ref="addForm" :model="addForm" label-width="80px" :rules="rules">
                  <el-form-item label="备注信息" prop="remark">
                      <el-input v-model="addForm.remark" placeholder="请输入备注信息"></el-input>
                  </el-form-item>
                  <div class="dialog-footer">
                      <el-button type="info" @click="handleToClose">取消</el-button>
                      <el-button type="primary" @click="submitForm()">确定</el-button>
                  </div>
              </el-form>
          </el-dialog>
            </div>
  </div>      
</template>
<script>
export default {
  data() {
    return {
      addDialogVisible: false,
      // 查询参数
        searchInfo: {
            // 默认请求第一页
            pageNum: 1,
            // 默认请求10条数据
            pageSize: 10,
            nickName: '',
            phone: '',
            memberType: ''
        },
        total: 0,
        tableData: [],
        addForm: {
            id: '',
            remark: ''
        },
        rules: {
              remark: [
                  { required: true, message: '请输入备注信息', trigger: 'blur' },
                   {max: 30,message: "备注信息不能超过30个字" }
              ]
        },
        memberTypeList: [
          {value: 0,label:"非会员"},{value: 1,label:"普通会员"}
        ]  
    };
  },
  created() {
        // 获取数据列表
        this.getUsreInfoList();
    },
  methods: {
    async getUsreInfoList() {
            const res = await this.$axios.post('applet/user/getUserInfoList', this.searchInfo);
            if (res.data.code == 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            }else{
                this.$message.error(`${res.data.msg}`);
            }
        },
    search() {
        this.searchInfo.pageNum = 1;
        this.getUsreInfoList();
    },
    openRemarkDia(id){
        this.addForm.id = id
        this.addDialogVisible = true;
    },
    submitForm() {
        let that = this;
        that.$refs.addForm.validate(valid => {
            if (valid) {
                this.$axios
                    .post('applet/user/setUserRemark', {
                        id: that.addForm.id,
                        remark: that.addForm.remark
                    })
                    .then(res => {
                        if (res.data.code == 0) {
                            //新增成功后 置空表单数据 关闭弹窗  刷新列表
                            that.$message.success('保存成功');
                            that.addDialogVisible = false;
                            that.getUsreInfoList();
                            that.resetForm();
                        } else {
                            that.$message.error(res.data.data);
                        }
                    });
            } else {
                // console.log('error submit!!');
                return false;
            }
        });
    },
    resetForm() {
        this.$refs.addForm.resetFields();
    },
    handleToClose() {
        let that = this;
        that.$confirm('确认放弃对当前页面信息的保存吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        })
            .then(() => {
                that.$refs.addForm.resetFields();
                this.addDialogVisible = false;
            })
            .catch(() => {});
        // 重置表单
    },
    reset() {
          this.searchInfo = {
              // 默认请求第一页
              pageNum: 1,
              // 默认请求10条数据
              pageSize: 10,
              nickName: '',
              phone: '',
              memberType: ''
          }
          this.getUsreInfoList();
      },
      async toSetMember(id) {
          this.$confirm('确定要设置该用户成为会员吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              this.$axios
                  .get('applet/user/toSetMember', {
                      params : {
                          id: id
                      }
                  })
                  .then(res => {
                      if (res.data.code == 0) {
                          this.$message.success('设置成功');
                          this.getUsreInfoList();
                      } else {
                          this.$message.error(res.data.msg);
                      }
                  })
                  .catch(() => {
                      this.getUsreInfoList();
                  });
          });
      },
    async cancelMember(id) {
        this.$confirm('确定要取消该会员吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.$axios
                .get('applet/user/toSetUnMember', {
                    params : {
                        id: id
                    }
                })
                .then(res => {
                    if (res.data.code == 0) {
                        this.$message.success('设置成功');
                        this.getUsreInfoList();
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(() => {
                    this.getUsreInfoList();
                });
        });
    },
    handleSizeChange(pageSize) {
            this.pageNum = 1;
            this.searchInfo.pageSize = pageSize;
            this.getUsreInfoList();
        },
        handleCurrentChange(pageNum) {
            this.searchInfo.pageNum = pageNum;
            this.getUsreInfoList();
        }
  }
};
</script>
<style lang="less" scoped></style>
